import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import selectors from './selectors';

const options = {
  name: 'availabilityCodes',
  baseType: 'AVAILABILITY_CODES',
  apiEndpoint: 'availability_codes'
};

const operations = createMetadataAPIOperations(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
